/**
 * wishlist.js — BYSIMON Wishlist con localStorage
 * Tema: Whiff — v2.0
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'bysimon_wishlist';

  /* ── Storage ── */
  const EXPIRY_DAYS = 30; // giorni dopo i quali un prodotto scade

  function getWishlist() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      const now = Date.now();
      const maxAge = EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      const valid = list.filter(p => !p.addedAt || (now - p.addedAt) < maxAge);
      if (valid.length !== list.length) saveWishlist(valid);
      return valid;
    }
    catch { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) { console.warn('Wishlist: localStorage non disponibile', e); }
  }

  function isInWishlist(productId) {
    return getWishlist().some(p => String(p.id) === String(productId));
  }

  function addToWishlist(product) {
    const list = getWishlist();
    if (!list.some(p => String(p.id) === String(product.id))) {
      product.addedAt = Date.now();
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    const list = getWishlist().filter(p => String(p.id) !== String(productId));
    saveWishlist(list);
  }

  /* ── Badge contatore nel header ── */
  function updateBadge() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    document.querySelectorAll('[data-wishlist-header] svg').forEach(svg => {
      svg.style.fill = count > 0 ? '#ef4444' : 'none';
      svg.style.stroke = count > 0 ? '#ef4444' : 'currentColor';
    });
  }

  /* ── Aggiorna stato bottoni ── */
  function updateButtons(productId) {
    const selector = productId
      ? `[data-wishlist-btn][data-product-id="${productId}"]`
      : '[data-wishlist-btn]';

    document.querySelectorAll(selector).forEach(btn => {
      const id = btn.dataset.productId;
      const active = isInWishlist(id);
      btn.classList.toggle('wishlist-btn--active', active);
      btn.setAttribute('aria-label',
        active
          ? `Rimuovi ${btn.dataset.productTitle} dalla wishlist`
          : `Aggiungi ${btn.dataset.productTitle} alla wishlist`
      );
    });
  }

  /* ── Toast ── */
  function showToast(message) {
    let toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('wishlist-toast--visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('wishlist-toast--visible'), 2500);
  }

  /* ── Click handler ── */
  function handleWishlistClick(e) {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const { productId, productHandle, productTitle, productImage, productPrice, productUrl } = btn.dataset;

    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      showToast(`"${productTitle}" rimosso dai preferiti`);
    } else {
      addToWishlist({ id: productId, handle: productHandle, title: productTitle, image: productImage, price: productPrice, url: productUrl });
      showToast(`"${productTitle}" aggiunto ai preferiti ♥`);
    }

    updateButtons(productId);
    updateBadge();

    // Aggiorna la pagina wishlist se siamo su di essa
    if (typeof window.renderWishlistPage === 'function') {
      window.renderWishlistPage();
    }
  }

  /* ── Init ── */
  function init() {
    document.addEventListener('click', handleWishlistClick);
    updateButtons();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Esposizione pubblica per uso esterno
  window.Wishlist = { getWishlist, addToWishlist, removeFromWishlist, isInWishlist, updateButtons, updateBadge };

})();
